export default "__VITE_ASSET__ca25b1c5__"